import React from "react";
import Icon from "./Icon.jsx";
import AppUtils from "@src/utils/appUtils";
import PropTypes from "prop-types";

const ExcludedBadgeCircular = ({ size = "medium" }) => {
  const outerWidth = size === "big" ? 250 : 144;
  const innerWidth = size === "big" ? 210 : 110;
  const iconWidth = size === "big" ? "180" : "5xl";
  return (
    <div
      className="mx-auto flex items-center relative bg-silver-400 rounded-full"
      style={{ width: outerWidth, height: outerWidth }}
    >
      <div
        className="mx-auto flex items-center relative bg-silver-100 rounded-full"
        style={{ width: innerWidth, height: innerWidth }}
      >
        <div
          className="flex items-center justify-center"
          style={{ width: "100%", height: "100%", zIndex: 42 }}
        >
          <Icon
            textColor={"silver-600"}
            name={"ban"}
            backgroundColor={"silver-300"}
            padding={true}
            size={iconWidth}
          />
        </div>
      </div>
    </div>
  );
};

export const excludedBadgeCircularControls = {
  size: {
    propType: PropTypes.string,
    description: "Size option",
    controlType: "select",
    options: ["medium", "big"],
  },
};

ExcludedBadgeCircular.PropTypes = AppUtils.getPropTypeFromControls(
  excludedBadgeCircularControls,
);

export default ExcludedBadgeCircular;
